import React, { useEffect, useState } from "react";
import "./association.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import CardEvent from "../../components/cardEvent/CardEvent";
import ListTopic from "../../components/listTopic/ListTopic";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import FollowerBox from "./components/followerBox/FollowerBox";
import CustomDialog from "../../components/customDialog/CustomDialog";
import ClickableImageWithModal from "../../components/clickableImageWithModal/ClickableImageWithModal";
import WaitingBox from "./components/waitingBox/WaitingBox";
import CustomTabs from "../../components/customTabs/CustomTabs";
import CalendarAssociation from "./components/calendarAssociation/CalendarAssociation";

import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";

import { t } from "i18next";
import {
  becomeVolunteerOfAssociationWS,
  deleteFavouriteAssociationWS,
  exitFromAssociationWS,
  getEventOfAssociationHistoryWS,
  getEventOfAssociationWS,
  getInfoAssociationWS,
  insertFavouriteAssociationWS,
  pushVisitWS,
} from "./api/associationApi";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { isEmpty } from "../../utils/validation";
import { gestioneSnackbar } from "../../utils/common";
import { Button, Row, Col, Stack } from "react-bootstrap";

const Association = () => {
  const navigate = useNavigate();
  const { id_association } = useParams();
  const [searchParams] = useSearchParams();
  const preview = searchParams.get("preview");

  const [data, setData] = useState([]);
  const [listEvent, setListEvent] = useState([]);
  const [listHistoryEvent, setListHistoryEvent] = useState([]);
  const [alreadyFollow, setAlreadyFollow] = useState(false);
  const [numberOfFollowers, setNumberOfFollowers] = useState(0);
  const [iAmVolunteer, setIAmVolunteer] = useState(false);
  const [iAmWaiting, setIAmWaiting] = useState(false);
  const [limit, setLimit] = useState(5);

  const [isCalendar, setIsCalendar] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dataCalendar, setDataCalendar] = useState({});

  console.log(selectedDate);

  useEffect(() => {
    pushVisitWS(id_association);

    getInfoAssociationWS(id_association)
      .then((res) => {
        setData(res);
        setAlreadyFollow(res.favourite);
        setIAmVolunteer(res.i_am_volunteer);
        setIAmWaiting(res.i_am_waiting);
        setNumberOfFollowers(res.followers);
      })
      .catch((err) => console.log(err));

    getEventOfAssociationWS(id_association, limit)
      .then((res) => {
        setListEvent(res.events);
        setDataCalendar(res.calendar);

        if (res.calendar) setIsCalendar(true);
        else setIsCalendar(false);
      })
      .catch((err) => console.log(err));

    getEventOfAssociationHistoryWS(id_association)
      .then((res) => setListHistoryEvent(res))
      .catch((err) => console.log(err));
  }, []);

  const handleClickFollow = () => {
    if (!alreadyFollow) {
      insertFavouriteAssociationWS(id_association)
        .then((res) => {
          setAlreadyFollow(true);
          setNumberOfFollowers((prev) => prev + 1);
        })
        .catch((error) => {
          gestioneSnackbar(true, error.message, "error");
        });
    } else {
      deleteFavouriteAssociationWS(id_association)
        .then((res) => {
          setAlreadyFollow(false);
          setNumberOfFollowers((prev) => prev - 1);
        })
        .catch((error) => {
          gestioneSnackbar(true, error.message, "error");
        });
    }
  };

  const handleClickVolunteer = () => {
    if (!iAmVolunteer) {
      becomeVolunteerOfAssociationWS(id_association)
        .then((res) => {
          gestioneSnackbar(true, res.message, "success");
          setAlreadyFollow(true);
          setIAmWaiting(true);
        })
        .catch((error) => {
          gestioneSnackbar(true, error, "error");
        });
    } else {
      exitFromAssociationWS(id_association)
        .then((res) => {
          window.location.reload();
        })
        .catch((error) => {
          gestioneSnackbar(true, error.message, "error");
        });
    }
  };

  return (
    <>
      <HeaderBar back={true} title={t("common.details")} />
      {!isEmpty(data) ? (
        <div className="association-container container-responsive">
          <Row sm={1} md={1} lg={2} xl={2} className="g-2">
            <Col
              sm={12}
              md={12}
              lg={6}
              xl={6}
              className="d-flex justify-content-center"
            >
              <div className="left-column-association">
                <Stack className="association-header mt-4" gap={4}>
                  {iAmWaiting ? (
                    <WaitingBox
                      variant="warning"
                      text={t("association.waiting_user")}
                    />
                  ) : null}
                  <Stack direction="horizontal" gap={3}>
                    <ClickableImageWithModal
                      src={
                        data.image
                          ? "data:" + data.image_type + ";base64," + data.image
                          : "/no_img.png"
                      }
                      alt="logo"
                      style={{
                        borderRadius: 20,
                        height: 100,
                        width: 100,
                        objectFit: "cover",
                      }}
                    />
                    <Stack gap={4}>
                      <span className="name-association">{data.name}</span>
                      <div className="d-flex justify-content-end">
                        <FollowerBox numberOfFollowers={numberOfFollowers} />
                      </div>
                    </Stack>
                  </Stack>

                  <p className="description-association">{data.description}</p>

                  <Stack gap={1} className="site-web-and-address-association">
                    {data.address ? (
                      <Stack direction="horizontal" gap={1}>
                        <PlaceOutlinedIcon />
                        {data.address}
                      </Stack>
                    ) : null}
                    {data.site_web ? (
                      <Stack direction="horizontal" gap={1}>
                        <LanguageOutlinedIcon />
                        <a href={data.site_web}>{data.site_web}</a>
                      </Stack>
                    ) : null}
                  </Stack>

                  <Stack
                    className="cta-follow-become-volunteer f-flex align-items-center justify-content-center"
                    gap={3}
                    direction="horizontal"
                  >
                    {!alreadyFollow ? (
                      <Button variant="success" onClick={handleClickFollow}>
                        <div className="content-button">
                          <VolunteerActivismIcon />
                          {t("common.follow_association")}
                        </div>
                      </Button>
                    ) : (
                      <CustomDialog
                        title={t("association.unfollow_modal.title")}
                        body={t("association.unfollow_modal.body")}
                        callback={() => handleClickFollow()}
                        trigger={
                          <Button variant="info">
                            <div className="content-button">
                              <VolunteerActivismIcon />
                              {t("common.follow_association_already")}
                            </div>
                          </Button>
                        }
                      />
                    )}
                    {!iAmVolunteer ? (
                      <Button
                        variant={iAmVolunteer ? "info" : "success"}
                        onClick={handleClickVolunteer}
                      >
                        <div className="content-button">
                          {t("association.become_volunteer")}
                        </div>
                      </Button>
                    ) : (
                      <CustomDialog
                        title={t(
                          "association.exit_from_association_modal.title"
                        )}
                        body={t("association.exit_from_association_modal.body")}
                        callback={() => handleClickVolunteer()}
                        trigger={
                          <Button variant="info">
                            <div className="content-button">
                              {t("association.i_am_volunteer")}
                            </div>
                          </Button>
                        }
                      />
                    )}
                  </Stack>

                  {!isEmpty(data.topic) ? (
                    <ListTopic
                      data={data.topic}
                      title={t("association.topic")}
                    />
                  ) : null}
                  {!preview ? (
                    <div className="d-flex justify-content-end align-items-end mt-4 mb-4">
                      <Button
                        variant="success"
                        onClick={() =>
                          navigate(`/user-question/${id_association}`)
                        }
                      >
                        {t("common.make_question")}
                      </Button>
                    </div>
                  ) : null}
                </Stack>
              </div>
            </Col>
            <Col
              sm={12}
              md={12}
              lg={6}
              xl={6}
              className="d-flex justify-content-center mt-4"
            >
              <Stack
                direction="vertical"
                gap={3}
                className="wrapper-association-list-event"
              >
                <CustomTabs
                  tabs={[
                    {
                      text: t("association.calendar_future_events"),
                      onClick: () => setIsCalendar(true),
                      isSelected: isCalendar,
                    },
                    {
                      text: t("association.list_event"),
                      onClick: () => setIsCalendar(false),
                      isSelected: !isCalendar,
                    },
                  ]}
                />
                <div className="list-event">
                  <div className="title-section mb-2 mt-2">
                    {isCalendar
                      ? t("association.calendar_future_events")
                      : t("association.list_event")}
                  </div>
                  {isCalendar ? (
                    selectedDate && !isEmpty(dataCalendar) ? (
                      <CalendarAssociation
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        dataCalendar={dataCalendar}
                      />
                    ) : (
                      <div>
                        {t("association.association_not_have_future_event")}
                      </div>
                    )
                  ) : (
                    <>
                      {!isEmpty(listEvent) ? (
                        <>
                          {listEvent.map((item) => (
                            <CardEvent
                              key={item.id}
                              id={item.id}
                              title={item.name}
                              associationName={item.name_association}
                              eventAddress={item.address}
                              startDatetime={item.start_date}
                              photo={item.photo[0] ?? null}
                              numberLike={item.numberLike}
                              isLike={item.is_like}
                            />
                          ))}

                          <div className="view-more-button">
                            <Button
                              variant="light"
                              onClick={() => {
                                setLimit(limit + 10);
                                getEventOfAssociationWS(id_association, limit)
                                  .then((res) => setListEvent(res.events))
                                  .catch((err) => console.log(err));
                              }}
                            >
                              {t("common.view_more")}
                            </Button>
                          </div>
                        </>
                      ) : null}
                      {!isEmpty(listHistoryEvent) ? (
                        <>
                          <div className="title-section mb-2 mt-2">
                            {t("association.finished_event")}
                          </div>
                          {listHistoryEvent.map((item) => (
                            <CardEvent
                              history={true}
                              key={item.id}
                              id={item.id}
                              title={item.name}
                              associationName={item.name_association}
                              eventAddress={item.address}
                              startDatetime={item.start_date}
                              photo={item.photo[0] ?? null}
                              numberLike={item.numberLike}
                              isLike={item.is_like}
                            />
                          ))}
                        </>
                      ) : null}
                    </>
                  )}
                </div>
              </Stack>
            </Col>
          </Row>
          <VoidSpace />
        </div>
      ) : null}
    </>
  );
};

export default Association;
